import * as React from 'react'
import { get } from '../lib/config'
import { Suggest } from 'react-geosuggest'
import LogoComponent from 'src/components/LogoComponent';
import RegistrationForm from 'src/components/RegistrationForm';
import { IRegistrationSubmission } from 'src/App';
import * as Styles from '../styles/PreArrivalPage.styles'
import { TouristPage, ITouristContent } from './TouristPage'

interface IPreArrivalState {
  lat: number
  lng: number
  renderPreArrival: boolean
  isTourist?: boolean
  isLocal?: boolean
  isLoading: boolean
  addressEntered: boolean
}

export interface IPreArrivalRegistrationProps {
  content: any
  touristContent?: ITouristContent
  locale: string
  logo: {
    imageUrl: string,
    alt: string
  };
  language: string
  changeLocale(e: React.MouseEvent<HTMLButtonElement, MouseEvent>): void
  submitRegistration(payload: IRegistrationSubmission): void
}

export class PreArrivalPage extends React.Component<IPreArrivalRegistrationProps,IPreArrivalState> {
  constructor(props:IPreArrivalRegistrationProps) {
    super(props)
    this.state = {
      lat: 0,
      lng: 0,
      renderPreArrival: true,
      isLoading: false,
      addressEntered: false
    }
  }

  // tslint:disable-next-line
  // private _geoSuggest: any
  public render() {
    const { renderPreArrival, lat, lng, isTourist, isLocal, isLoading, addressEntered } = this.state
    const { touristContent } = this.props
    const theme = touristContent!.theme.content
    if (!theme) {
      return null
    }
    // console.log(this._geoSuggest)
    // console.log('Content is ',touristContent, ' theme is ',theme, ' props ',this.props.content)
    const disabled = lat === 0 || lng === 0
    return (
      renderPreArrival ?
      <TouristPage
        touristContent={touristContent}
        content={this.props.content}
        locale={this.props.locale}
        isLoading={isLoading}
        isLocal={isLocal}
        isTourist={isTourist}
        addressEntered={addressEntered}
        disabled={disabled}
        handleClick={this.handleClick}
        changeLocale={this.props.changeLocale}
        onSuggestSelect={this.onSuggestSelect}
        handleSuccessClick={this.handleSuccessClick}
        handleFailureClick={this.handleFailureClick}
      />
      :
      <Styles.MainWrapper theme={theme}>
          <LogoComponent logo={this.props.logo} />
          <Styles.Wrapper>
              <RegistrationForm
                  changeLocale={this.props.changeLocale}
                  content={this.props.content}
                  locale={this.props.locale}
                  language={this.props.language}
                  submitRegistration={this.props.submitRegistration}
                  hideQRCode={true}
                  source={'digital_tourist_passport_external'}
              />
          </Styles.Wrapper>
      </Styles.MainWrapper>
    )
  }
  private onSuggestSelect = (suggest: Suggest) => {
    if (suggest) {
      this.setState({
        lat: suggest.location.lat,
        lng: suggest.location.lng
      })
    }
  }
  private handleClick = async (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    const { lat, lng } = this.state
    e.preventDefault()
    this.setState({
      isLoading: true
    })
    if (lat && lng) {
      const centres = await fetch(`${get('registrationApiUrl')}/centre/${get('centreId')}`, {
        method: 'GET',
      }).then(response => response.json())
      const to = google.maps.geometry.spherical.computeDistanceBetween(
        new google.maps.LatLng(lat, lng),
        new google.maps.LatLng(centres[0].latitude, centres[0].longitude)
      ) / 1000
      // console.log('Eligibility ',to && to > get('prearrivalEligibility'))
      if (to && to > get('prearrivalEligibility')) {
        this.setState({
          isTourist: true,
          isLocal: false,
          isLoading: false,
          addressEntered: true
        })
      } else {
        this.setState({
          isTourist: false,
          isLocal: true,
          isLoading: false,
          addressEntered: true
        })
      }
      window.scrollTo(0,document.body.scrollHeight);
      }
  }
  private handleSuccessClick = () => (
    this.setState({
      renderPreArrival: false
    })
  )
  private handleFailureClick = () => (
    this.setState({
      addressEntered: false,
      isLocal: false
    })
  )
}



// WEBPACK FOOTER //
// ./src/pages/PreArrivalPage.tsx